import Form from 'components/form/Form';
import SearchInput from 'components/form-elements/search-input/SearchInput';

import { IMenuSearch } from 'source/NFR.types';

const MenuSearch: React.FC<IMenuSearch> = ({ form, input, submitLabel }) => (
  <Form className="menu-search" showSubmitButton={false} {...form}>
    <SearchInput idPrefix="menu-search" {...input} />
    <button className="menu-search--submit" type="submit">
      {submitLabel}
    </button>
  </Form>
);

MenuSearch.displayName = 'MenuSearch';

export default MenuSearch;
